import React from 'react'

const Temp = () => (
  <div />
)

export default Temp
